import { useTranslation } from 'react-i18next';

import { useDeleteTeamMember } from '@/modules/settings/Team/apiHooks';
import { Button, Typography } from '@/shared/components/atoms';
import { useModal } from '@/shared/hooks/context/modalContext/useModal';

import Archive from '~/images/shared/Archive.svg';
import Trash from '~/images/shared/TrashWithoutColor.svg';

const ArchiveDeleteConfirmationModal: React.FC<{
  id: number;
  type: 'delete' | 'archive';
}> = ({ id, type }) => {
  const { t } = useTranslation('common');
  const { closeModal } = useModal();
  const { mutate: deleteTeamMember } = useDeleteTeamMember();

  const handleArchiving = () => {
    deleteTeamMember(id, {
      onSuccess: () => {
        closeModal();
      },
    });
  };

  return (
    <div className='flex w-full flex-col items-center justify-center gap-32'>
      <div className='flex h-64 w-64 items-center justify-center rounded-full bg-error-90 text-center text-40 text-error-400'>
        {type === 'delete' ? <Trash /> : <Archive />}
      </div>
      <div className='flex w-full flex-col items-center text-center'>
        <Typography variant='h3'>
          {t(
            type === 'delete'
              ? 'delete-team-confirmation'
              : 'archive-team-confirmation'
          )}
        </Typography>
        <Typography variant='body2' className='w-5/6 text-surface-10'>
          {t(
            type === 'delete'
              ? 'delete-team-confirmation-details'
              : 'archive-team-confirmation-details'
          )}
        </Typography>
      </div>
      <div className='mt-20 flex w-full flex-grow justify-end gap-16'>
        <Button
          variant='text'
          type='button'
          size='sm'
          className='h-56 w-full !rounded-xl border-xs border-grey-200'
          onClick={handleArchiving}
        >
          {t(type === 'delete' ? 'delete' : 'deactivate')}
        </Button>
        <Button
          variant='filled'
          type='button'
          size='sm'
          className='h-56 w-full !rounded-xl border-xs border-grey-200'
          onClick={() => {
            closeModal();
          }}
        >
          {t('back')}
        </Button>
      </div>
    </div>
  );
};

export { ArchiveDeleteConfirmationModal };
